export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-3-e3d423e3d66fcf2eabcae017acc9bd52.jpg";